// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml = require("rescript/lib/js/caml.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var CheckboxInput$ReactHooksTemplate = require("../common/CheckboxInput.res.js");
var CampaignsDataField$ReactHooksTemplate = require("../general_settings/campaignsDataField.res.js");

var emptyState = {
  dataFields: /* [] */0,
  searchFilter: "",
  showDropdown: false,
  error: "",
  edited: false
};

function CampaignDataFieldsForm(props) {
  var saveCampaignDataFields = props.saveCampaignDataFields;
  var deleteCampaignDataField = props.deleteCampaignDataField;
  var updateCampaignDataFields = props.updateCampaignDataFields;
  var campaignDataFields = props.campaignDataFields;
  var match = React.useState(function (param) {
        return emptyState;
      });
  var setState = match[1];
  var state = match[0];
  var domElement = React.useRef(null);
  var handleOutsideClick = function ($$event) {
    var targetElement = $$event.target;
    var selectBoxElement = Belt_Option.getExn(Caml_option.nullable_to_opt(domElement.current));
    if (!selectBoxElement.contains(targetElement)) {
      return Curry._1(setState, (function (state) {
                    return {
                            dataFields: state.dataFields,
                            searchFilter: state.searchFilter,
                            showDropdown: false,
                            error: state.error,
                            edited: state.edited
                          };
                  }));
    }
    
  };
  React.useEffect((function (param) {
          document.addEventListener("mousedown", handleOutsideClick);
          Js_promise.then_((function (dataFields) {
                  return Promise.resolve(Curry._1(setState, (function (state) {
                                    return {
                                            dataFields: dataFields,
                                            searchFilter: state.searchFilter,
                                            showDropdown: state.showDropdown,
                                            error: state.error,
                                            edited: state.edited
                                          };
                                  })));
                }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/data_fields?paginate=false", (function (param) {
                      return Json_decode.field("data_fields", (function (param) {
                                    return Json_decode.list(DataField$ReactHooksTemplate.decode, param);
                                  }), param);
                    })));
          return (function (param) {
                    document.removeEventListener("mousedown", handleOutsideClick);
                  });
        }), []);
  var filteredDataFields = Belt_List.keep(state.dataFields, (function (a) {
          return DataField$ReactHooksTemplate.name(a).toLowerCase().includes(state.searchFilter.toLowerCase());
        }));
  var availableDataFields = Belt_List.filter(filteredDataFields, (function (df) {
          return !Belt_List.some(campaignDataFields, (function (cdf) {
                        return DataField$ReactHooksTemplate.name(CampaignsDataField$ReactHooksTemplate.dataField(cdf)) === DataField$ReactHooksTemplate.name(df);
                      }));
        }));
  var handleSelection = function (df) {
    var campaignDataField = CampaignsDataField$ReactHooksTemplate.setDataField(CampaignsDataField$ReactHooksTemplate.empty(), df);
    var exists = Belt_List.has(campaignDataFields, campaignDataField, (function (a, b) {
            return DataField$ReactHooksTemplate.name(CampaignsDataField$ReactHooksTemplate.dataField(a)) === DataField$ReactHooksTemplate.name(CampaignsDataField$ReactHooksTemplate.dataField(b));
          }));
    var updated = exists ? Belt_List.keep(campaignDataFields, (function (a) {
              return !Caml_obj.equal(a, campaignDataField);
            })) : Belt_List.add(campaignDataFields, campaignDataField);
    Curry._1(updateCampaignDataFields, updated);
    Curry._1(setState, (function (state) {
            return {
                    dataFields: state.dataFields,
                    searchFilter: "",
                    showDropdown: false,
                    error: "",
                    edited: true
                  };
          }));
  };
  var handleKeyDown = function ($$event) {
    var key = $$event.key;
    if (key !== "Enter") {
      return ;
    }
    $$event.preventDefault();
    if (state.showDropdown && Belt_List.size(availableDataFields) > 0) {
      var availableOption = Belt_List.head(Belt_List.sort(availableDataFields, (function (a, b) {
                  return Caml.string_compare(DataField$ReactHooksTemplate.name(a), DataField$ReactHooksTemplate.name(b));
                })));
      if (availableOption !== undefined) {
        return handleSelection(Caml_option.valFromOption(availableOption));
      } else {
        return ;
      }
    }
    if (!state.showDropdown) {
      return ;
    }
    var matchedOption = Belt_List.getBy(state.dataFields, (function (df) {
            return DataField$ReactHooksTemplate.name(df).toLowerCase() === state.searchFilter.toLowerCase();
          }));
    if (matchedOption === undefined) {
      return Curry._1(setState, (function (state) {
                    return {
                            dataFields: state.dataFields,
                            searchFilter: state.searchFilter,
                            showDropdown: state.showDropdown,
                            error: "No available data fields found",
                            edited: state.edited
                          };
                  }));
    }
    var df = Caml_option.valFromOption(matchedOption);
    var isAlreadySelected = Belt_List.some(campaignDataFields, (function (cdf) {
            return DataField$ReactHooksTemplate.name(CampaignsDataField$ReactHooksTemplate.dataField(cdf)) === DataField$ReactHooksTemplate.name(df);
          }));
    if (isAlreadySelected) {
      return Curry._1(setState, (function (state) {
                    return {
                            dataFields: state.dataFields,
                            searchFilter: state.searchFilter,
                            showDropdown: state.showDropdown,
                            error: "Data field already selected",
                            edited: state.edited
                          };
                  }));
    } else {
      return Curry._1(setState, (function (state) {
                    return {
                            dataFields: state.dataFields,
                            searchFilter: state.searchFilter,
                            showDropdown: state.showDropdown,
                            error: "No available data fields found",
                            edited: state.edited
                          };
                  }));
    }
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("h2", {
                              children: "Data Fields In Campaign",
                              className: "text-lg font-semibold"
                            }),
                        JsxRuntime.jsx("button", {
                              children: "Save",
                              className: state.edited ? "bg-pigmentblue hover:bg-cetaceanblue px-6 py-2 rounded text-sm text-white font-normal" : "bg-pigmentblue hover:bg-cetaceanblue px-6 py-2 rounded text-sm text-white font-normal disabled-input",
                              disabled: !state.edited,
                              onClick: (function (param) {
                                  Curry._1(saveCampaignDataFields, undefined);
                                  Curry._1(setState, (function (state) {
                                          return {
                                                  dataFields: state.dataFields,
                                                  searchFilter: state.searchFilter,
                                                  showDropdown: state.showDropdown,
                                                  error: state.error,
                                                  edited: false
                                                };
                                        }));
                                })
                            })
                      ],
                      className: "flex justify-between items-center"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("label", {
                              children: "DataField",
                              className: "text-sm font-medium text-gray-700 text-right pr-4 pt-2"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("input", {
                                              className: "w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 pr-10",
                                              placeholder: "Type to search data fields...",
                                              type: "text",
                                              onKeyDown: handleKeyDown,
                                              onFocus: (function (param) {
                                                  Curry._1(setState, (function (state) {
                                                          return {
                                                                  dataFields: state.dataFields,
                                                                  searchFilter: state.searchFilter,
                                                                  showDropdown: true,
                                                                  error: state.error,
                                                                  edited: state.edited
                                                                };
                                                        }));
                                                }),
                                              onChange: (function (e) {
                                                  var value = Utils$ReactHooksTemplate.formTargetValue(e);
                                                  Curry._1(setState, (function (state) {
                                                          return {
                                                                  dataFields: state.dataFields,
                                                                  searchFilter: value,
                                                                  showDropdown: true,
                                                                  error: "",
                                                                  edited: true
                                                                };
                                                        }));
                                                })
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx("svg", {
                                                    children: JsxRuntime.jsx("path", {
                                                          d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z",
                                                          strokeLinecap: "round",
                                                          strokeLinejoin: "round",
                                                          strokeWidth: "2"
                                                        }),
                                                    className: "w-4 h-4 text-gray-400",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    viewBox: "0 0 24 24"
                                                  }),
                                              className: "absolute right-3 top-1/2 transform -translate-y-1/2"
                                            })
                                      ],
                                      className: "relative"
                                    }),
                                state.error !== "" ? JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx("span", {
                                              children: state.error,
                                              className: "text-xs text-firebrick"
                                            }),
                                        className: "mt-1"
                                      }) : null,
                                state.showDropdown && Belt_List.size(availableDataFields) > 0 ? JsxRuntime.jsx("div", {
                                        children: $$Array.of_list(Belt_List.map(Belt_List.sort(availableDataFields, (function (a, b) {
                                                        return Caml.string_compare(DataField$ReactHooksTemplate.name(a), DataField$ReactHooksTemplate.name(b));
                                                      })), (function (df) {
                                                    return JsxRuntime.jsx("div", {
                                                                children: DataField$ReactHooksTemplate.name(df),
                                                                className: "px-3 py-2 text-sm cursor-pointer hover:bg-gray-200 border-b border-gray-100 last:border-b-0",
                                                                onClick: (function (param) {
                                                                    handleSelection(df);
                                                                  })
                                                              }, DataField$ReactHooksTemplate.name(df));
                                                  }))),
                                        className: "absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-auto"
                                      }) : null,
                                state.showDropdown && Belt_List.size(availableDataFields) === 0 && state.error === "" ? JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx("div", {
                                              children: "No available data fields found",
                                              className: "px-3 py-2 text-sm text-gray-500"
                                            }),
                                        className: "absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg"
                                      }) : null
                              ],
                              ref: Caml_option.some(domElement),
                              className: "relative w-2/4"
                            })
                      ],
                      className: "flex items-start"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("table", {
                            children: [
                              JsxRuntime.jsx("thead", {
                                    children: JsxRuntime.jsxs("tr", {
                                          children: [
                                            JsxRuntime.jsx("th", {
                                                  children: "Name",
                                                  className: "text-left w-1/3 font-medium py-2 px-4"
                                                }),
                                            JsxRuntime.jsx("th", {
                                                  children: "Mandatory",
                                                  className: "text-left w-1/6 font-medium py-2 px-4"
                                                }),
                                            JsxRuntime.jsx("th", {
                                                  children: "Show in response report",
                                                  className: "text-left w-1/6 font-medium py-2 px-4"
                                                }),
                                            JsxRuntime.jsx("th", {
                                                  children: "Action",
                                                  className: "text-left w-1/6 font-medium py-2 px-4"
                                                })
                                          ]
                                        }),
                                    className: "bg-gray-50 text-gray-600"
                                  }),
                              JsxRuntime.jsx("tbody", {
                                    children: $$Array.of_list(Belt_List.mapWithIndex(campaignDataFields, (function (param, df) {
                                                return JsxRuntime.jsxs("tr", {
                                                            children: [
                                                              JsxRuntime.jsx("td", {
                                                                    children: DataField$ReactHooksTemplate.name(CampaignsDataField$ReactHooksTemplate.dataField(df)),
                                                                    className: "p-4"
                                                                  }),
                                                              JsxRuntime.jsx("td", {
                                                                    children: JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                                                          checked: CampaignsDataField$ReactHooksTemplate.mandatory(df),
                                                                          disabled: false,
                                                                          label: "",
                                                                          handleChange: (function (param) {
                                                                              var toggledCampaginDataField = CampaignsDataField$ReactHooksTemplate.setMandatory(df, !CampaignsDataField$ReactHooksTemplate.mandatory(df));
                                                                              var updated = Belt_List.map(campaignDataFields, (function (x) {
                                                                                      if (Caml_obj.equal(CampaignsDataField$ReactHooksTemplate.dataField(x), CampaignsDataField$ReactHooksTemplate.dataField(toggledCampaginDataField))) {
                                                                                        return toggledCampaginDataField;
                                                                                      } else {
                                                                                        return x;
                                                                                      }
                                                                                    }));
                                                                              Curry._1(updateCampaignDataFields, updated);
                                                                              Curry._1(setState, (function (state) {
                                                                                      return {
                                                                                              dataFields: state.dataFields,
                                                                                              searchFilter: state.searchFilter,
                                                                                              showDropdown: state.showDropdown,
                                                                                              error: state.error,
                                                                                              edited: true
                                                                                            };
                                                                                    }));
                                                                            }),
                                                                          checkboxClassName: "custom_checkbox mt-5-px flex items-center"
                                                                        }),
                                                                    className: "p-4"
                                                                  }),
                                                              JsxRuntime.jsx("td", {
                                                                    children: JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                                                          checked: CampaignsDataField$ReactHooksTemplate.showInReport(df),
                                                                          disabled: false,
                                                                          label: "",
                                                                          handleChange: (function (param) {
                                                                              var toggled = CampaignsDataField$ReactHooksTemplate.setShowInReport(df, !CampaignsDataField$ReactHooksTemplate.showInReport(df));
                                                                              var updated = Belt_List.map(campaignDataFields, (function (x) {
                                                                                      if (Caml_obj.equal(CampaignsDataField$ReactHooksTemplate.dataField(x), CampaignsDataField$ReactHooksTemplate.dataField(toggled))) {
                                                                                        return toggled;
                                                                                      } else {
                                                                                        return x;
                                                                                      }
                                                                                    }));
                                                                              Curry._1(updateCampaignDataFields, updated);
                                                                              Curry._1(setState, (function (state) {
                                                                                      return {
                                                                                              dataFields: state.dataFields,
                                                                                              searchFilter: state.searchFilter,
                                                                                              showDropdown: state.showDropdown,
                                                                                              error: state.error,
                                                                                              edited: true
                                                                                            };
                                                                                    }));
                                                                            }),
                                                                          checkboxClassName: "custom_checkbox mt-5-px flex items-center"
                                                                        }),
                                                                    className: "p-4"
                                                                  }),
                                                              JsxRuntime.jsx("td", {
                                                                    children: JsxRuntime.jsx("a", {
                                                                          children: JsxRuntime.jsx("img", {
                                                                                className: "h-5 w-5",
                                                                                src: Image$ReactHooksTemplate.trash
                                                                              }),
                                                                          className: "focus:outline-none",
                                                                          onClick: (function (param) {
                                                                              Curry._1(deleteCampaignDataField, df);
                                                                              Curry._1(setState, (function (state) {
                                                                                      return {
                                                                                              dataFields: state.dataFields,
                                                                                              searchFilter: state.searchFilter,
                                                                                              showDropdown: state.showDropdown,
                                                                                              error: state.error,
                                                                                              edited: true
                                                                                            };
                                                                                    }));
                                                                            })
                                                                        }),
                                                                    className: "p-4"
                                                                  })
                                                            ],
                                                            className: "border-t border-gray-200"
                                                          });
                                              })))
                                  })
                            ],
                            className: "w-3/5 bg-white text-sm"
                          }),
                      className: "max-h-4/5 overflow-y-auto"
                    })
              ],
              className: "space-y-6 h-full"
            });
}

var make = CampaignDataFieldsForm;

exports.emptyState = emptyState;
exports.make = make;
/* react Not a pure module */
